import { render, staticRenderFns } from "./FacultiesProgrammesAdmin.vue?vue&type=template&id=8be33ed6&scoped=true&"
import script from "./FacultiesProgrammesAdmin.vue?vue&type=script&lang=js&"
export * from "./FacultiesProgrammesAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FacultiesProgrammesAdmin.vue?vue&type=style&index=0&id=8be33ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be33ed6",
  null
  
)

export default component.exports